export interface RoomType {
  roomTypeId: number;
  roomTypeName: string;
  description: string;
  maxOccupancy: number;
  basePrice: number;
  createdAt: Date;
  updatedAt: Date;
}

// Default initialization for POST request
export const InitialRoomType: RoomType = {
  roomTypeId: 0,
  roomTypeName: "",
  description: "",
  maxOccupancy: 0,
  basePrice: 0,
  createdAt: new Date(),
  updatedAt: new Date()
};